import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import AuthContext from '../context/AuthContext';

const PrivateRoute = ({ children }) => {
  const { user, loading } = useContext(AuthContext);

  if (loading) {
    return <div className="text-center mt-5">Yükleniyor...</div>;
  }

  // Kullanıcı varsa sayfayı göster, yoksa Login'e at
  return user ? children : <Navigate to="/login" />;
};

export default PrivateRoute;
